import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_TRIM implements Validator {

    public static id = 'CTRL_TRIM';
    private message = 'error.ctr_9103';


    public LOG: LogService = new LogService(CTRL_TRIM);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_TRIM.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const textWithStepId = ctrlMap.get(ctrl.value.rgCtrls.text);
                const textCtrl = form.controls[textWithStepId];
                if (textCtrl?.value && textCtrl.value.length > 0 && textCtrl.value.trim().length == 0) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '');
	}
}
